module.exports = __webpack_public_path__ + "static/media/offices (8).38ebe909.webp";